import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { PureComponent } from 'react';
import PT from 'prop-types';
import styled, { css } from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../3rdPartyModules/_react-aria/focus/dist/useFocusRing-BO5gj-B1.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../3rdPartyModules/_react-aria/utils/dist/mergeProps-DMtmc2Zw.js';
import { f as focusOutline } from '../FocusIndicator/styleMixins/focusOutline-DNwtedBp.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { T as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { f as faSpinner } from '../LocalModules/storm-ui-icons/dist/esm/fortawesome-free-solid-svg-icons-B7FqziTJ-C1x4Faml.js';
import { I as Icon } from '../Icon/Icon-rcwnFk3r.js';

const globalStyles = /*#__PURE__*/css(["white-space:nowrap;border-radius:", ";cursor:", ";text-align:center;vertical-align:middle;border-width:1px;border-style:solid;user-select:auto;@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms ease;}"], ({
  theme
}) => theme.button.borderRadius, ({
  theme
}) => theme.button.cursor);
const colorMixin = themeValueSelector => css(["&&,&&:visited,&&:active,&&:link,&&:hover{color:", ";}"], themeValueSelector);

/*
 * Replace `colorMixin()` with this version if we want to only increase the Link
 * color rule specificity when `theme.link.overrideAuiLinkStyle === true`

const colorMixin = themeValueSelector => ({ theme }) =>{
  if (theme?.globals?.link?.overrideAuiLinkStyle === true) {
    return css`
    &&, &&:visited, &&:active, &&:link, &&:hover{
      color: ${themeValueSelector};
    }`;
  }
  return css`color: ${themeValueSelector};`;
};
*/

const normalStyles = /*#__PURE__*/css(["padding-top:", ";padding-bottom:", ";padding-inline-start:", ";padding-inline-end:", ";font-size:", ";", ""], ({
  theme
}) => theme.button.normal.paddingV, ({
  theme
}) => theme.button.normal.paddingV, ({
  theme
}) => theme.button.normal.paddingH, ({
  theme
}) => theme.button.normal.paddingH, ({
  theme
}) => theme.button.normal.fontSize, isMobile(css(["padding-top:", ";padding-bottom:calc(", " + 1px);padding-inline-start:", ";padding-inline-end:", ";font-size:", ";"], ({
  theme
}) => theme.button.normal.mobile.paddingV, ({
  theme
}) => theme.button.normal.mobile.paddingV, ({
  theme
}) => theme.button.normal.mobile.paddingH, ({
  theme
}) => theme.button.normal.mobile.paddingH, ({
  theme
}) => theme.button.normal.mobile.fontSize)));
const smallStyles = /*#__PURE__*/css(["padding-top:", ";padding-bottom:", ";padding-inline-start:", ";padding-inline-end:", ";font-size:", ";", ""], ({
  theme
}) => theme.button.small.paddingV, ({
  theme
}) => theme.button.small.paddingV, ({
  theme
}) => theme.button.small.paddingH, ({
  theme
}) => theme.button.small.paddingH, ({
  theme
}) => theme.button.small.fontSize, isMobile(css(["padding-top:", ";padding-bottom:", ";padding-inline-start:", ";padding-inline-end:", ";font-size:", ";"], ({
  theme
}) => theme.button.small.mobile.paddingV, ({
  theme
}) => theme.button.small.mobile.paddingV, ({
  theme
}) => theme.button.small.mobile.paddingH, ({
  theme
}) => theme.button.small.mobile.paddingH, ({
  theme
}) => theme.button.small.mobile.fontSize)));
const transparentStyles = /*#__PURE__*/css(["background:", ";border-color:", ";box-shadow:", ";", " :hover{background:", ";box-shadow:", ";}:active{background:", ";border-color:", ";}:disabled{cursor:not-allowed;outline:none;opacity:1;border-color:", ";", " background:", ";pointer-events:all;}"], ({
  theme
}) => theme.button.transparent.bg, ({
  theme
}) => theme.button.transparent.borderColor, ({
  theme
}) => theme.button.transparent.boxShadow, colorMixin(({
  theme
}) => theme.button.transparent.color), ({
  theme
}) => theme.button.transparent.bgHover, ({
  theme
}) => theme.button.transparent.boxShadow, ({
  theme
}) => theme.button.transparent.bgActive, ({
  theme
}) => theme.button.transparent.borderColorActive, ({
  theme
}) => theme.button.transparent.borderColorDisabled, colorMixin(({
  theme
}) => theme.button.transparent.colorDisabled), ({
  theme
}) => theme.button.transparent.bg);
const disabledLinkButtonMixin = /*#__PURE__*/css(["outline:none;pointer-events:none;opacity:1;", " cursor:not-allowed;border-color:", ";background:", ";"], colorMixin(({
  theme
}) => theme.button.default.colorDisabled), ({
  theme
}) => theme.button.default.borderColorDisabled, ({
  theme
}) => theme.button.default.bgDisabled);
const disabledPrimaryLinkButtonMixin = /*#__PURE__*/css(["outline:none;pointer-events:none;opacity:1;", " cursor:not-allowed;border-color:", ";background:", ";"], colorMixin(({
  theme
}) => theme.button.primary.colorDisabled), ({
  theme
}) => theme.button.primary.borderColorDisabled, ({
  theme
}) => theme.button.primary.bgDisabled);
const disabledTransparentLinkButtonMixin = /*#__PURE__*/css(["cursor:not-allowed;outline:none;pointer-events:none;opacity:1;border-color:", ";", " background:", ";"], ({
  theme
}) => theme.button.transparent.borderColorDisabled, colorMixin(({
  theme
}) => theme.button.transparent.colorDisabled), ({
  theme
}) => theme.button.transparent.bg);
const iconStyles = /*#__PURE__*/css(["margin-inline-end:", ";"], ({
  theme
}) => theme.spacing.mini);
const loadingStyles = /*#__PURE__*/css(["&&[aria-disabled=\"true\"]{cursor:not-allowed;outline:none;opacity:1;border-color:", ";", " background:", ";pointer-events:none;box-shadow:", ";}"], ({
  theme
}) => theme.button.default.borderColorDisabled, colorMixin(({
  theme
}) => theme.button.default.colorDisabled), ({
  theme
}) => theme.button.default.bgDisabled, ({
  theme
}) => theme.button.default.boxShadowDisabled);
const transparentloadingStyles = /*#__PURE__*/css(["&&[aria-disabled=\"true\"]{cursor:not-allowed;outline:none;opacity:1;border-color:", ";", " background:", ";pointer-events:none;box-shadow:", ";}"], ({
  theme
}) => theme.button.transparent.borderColorDisabled, colorMixin(({
  theme
}) => theme.button.transparent.colorDisabled), ({
  theme
}) => theme.button.transparent.bg, ({
  theme
}) => theme.button.default.boxShadowDisabled);
const defaultStyles = /*#__PURE__*/css(["background:", ";border-color:", ";", " box-shadow:", ";:hover{background:", ";box-shadow:", ";}:active{border-color:", ";background:", ";box-shadow:", ";}:disabled{cursor:not-allowed;outline:none;opacity:1;border-color:", ";", " background:", ";pointer-events:all;box-shadow:", ";}"], ({
  theme
}) => theme.button.default.bg, ({
  theme
}) => theme.button.default.borderColor, colorMixin(({
  theme
}) => theme.button.default.color), ({
  theme
}) => theme.button.default.boxShadow, ({
  theme
}) => theme.button.default.bgHover, ({
  theme
}) => theme.button.default.boxShadowHover, ({
  theme
}) => theme.button.default.borderColorActive, ({
  theme
}) => theme.button.default.bgActive, ({
  theme
}) => theme.button.default.boxShadowActive, ({
  theme
}) => theme.button.default.borderColorDisabled, colorMixin(({
  theme
}) => theme.button.default.colorDisabled), ({
  theme
}) => theme.button.default.bgDisabled, ({
  theme
}) => theme.button.default.boxShadowDisabled);
const primaryStyles = /*#__PURE__*/css(["background:", ";border-color:", ";", " box-shadow:", ";:hover{background:", ";box-shadow:", ";}:active{border-color:", ";background:", ";box-shadow:", ";}:disabled{cursor:not-allowed;outline:none;opacity:1;", " background:", ";border-color:", ";pointer-events:all;box-shadow:", ";}"], ({
  theme
}) => theme.button.primary.bg, ({
  theme
}) => theme.button.primary.borderColor, colorMixin(({
  theme
}) => theme.button.primary.color), ({
  theme
}) => theme.button.primary.boxShadow, ({
  theme
}) => theme.button.primary.bgHover, ({
  theme
}) => theme.button.primary.boxShadowHover, ({
  theme
}) => theme.button.primary.borderColorActive, ({
  theme
}) => theme.button.primary.bgActive, ({
  theme
}) => theme.button.primary.boxShadowActive, colorMixin(({
  theme
}) => theme.button.primary.colorDisabled), ({
  theme
}) => theme.button.primary.bgDisabled, ({
  theme
}) => theme.button.primary.borderColorDisabled, ({
  theme
}) => theme.button.primary.boxShadowDisabled);
const StyledIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30065889__sc-d3w8xm-0"
})(["", ";"], iconStyles);
const LoadingIcon = () => /*#__PURE__*/React__default.createElement(StyledIcon, {
  type: faSpinner
});
const StyledButton = /*#__PURE__*/styled('button').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    /*
     *`useFocusRing()` uses `onFocus` and `onBlur` props, so `mergeProps()` must be used to
     * make sure user supplied `onFocus` and `onBlur` are also called.
    */
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    focusVisible: isFocusVisible
  };
}).withConfig({
  componentId: "sc-storm-ui-30065889__sc-d3w8xm-1"
})(["", ";", ";", ";", ";", ";&&:focus{outline:none;", "}margin:0;"], ({
  theme
}) => theme.typography.base, globalStyles, ({
  $primary,
  $transparent
}) => {
  if ($transparent) {
    return transparentStyles;
  }
  if ($primary) {
    return primaryStyles;
  }
  return defaultStyles;
}, ({
  $small
}) => $small ? smallStyles : normalStyles, ({
  $loading,
  $transparent
}) => {
  if ($loading) {
    if ($transparent) {
      return transparentloadingStyles;
    }
    return loadingStyles;
  }
  return undefined;
}, ({
  focusVisible
}) => focusVisible && focusOutline);
const StyledLink = /*#__PURE__*/styled('a').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    /*
     *`useFocusRing()` uses `onFocus` and `onBlur` props, so `mergeProps()` must be used to
     * make sure user supplied `onFocus` and `onBlur` are also called.
    */
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    focusVisible: isFocusVisible
  };
}).withConfig({
  componentId: "sc-storm-ui-30065889__sc-d3w8xm-2"
})(["&,:visited,:active,:link{text-decoration:none;", ";", ";}", ";", ";", ";", ";display:inline-block;:focus{outline:none;", "}"], globalStyles, ({
  $disabled,
  $primary,
  $transparent
}) => {
  if ($disabled) {
    if ($transparent) {
      return disabledTransparentLinkButtonMixin;
    }
    if ($primary) {
      return disabledPrimaryLinkButtonMixin;
    }
    return disabledLinkButtonMixin;
  }
  return '';
}, ({
  theme
}) => theme.typography.base, ({
  $primary,
  $transparent
}) => {
  if ($transparent) {
    return transparentStyles;
  }
  if ($primary) {
    return primaryStyles;
  }
  return defaultStyles;
}, ({
  $disabled,
  $primary,
  $transparent
}) => {
  if ($disabled) {
    if ($transparent) {
      return disabledTransparentLinkButtonMixin;
    }
    if ($primary) {
      return disabledPrimaryLinkButtonMixin;
    }
    return disabledLinkButtonMixin;
  }
  return '';
}, ({
  $small
}) => $small ? smallStyles : normalStyles, ({
  focusVisible
}) => focusVisible && focusOutline);

/**
 * A `Buttonish` element represents a superset of the most common types of
 * elements our customers are using for the Button component.
 */

class Button extends PureComponent {
  render() {
    const {
      href,
      buttonRef,
      innerRef,
      disabled,
      primary,
      small,
      type,
      transparent,
      loading,
      loadingLabel,
      children,
      taktId,
      taktValue,
      onClick,
      ...rest
    } = this.props;
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('button')
    }, ({
      getDataTaktAttributes
    }) => {
      if (href) {
        return /*#__PURE__*/React__default.createElement(StyledLink, _extends({}, getDataTaktAttributes(), rest, {
          ref: buttonRef || innerRef
        }, disabled ? {
          'aria-disabled': true
        } : {
          href
        }, {
          tabIndex: disabled ? -1 : undefined,
          $disabled: disabled,
          $primary: primary,
          $small: small,
          $transparent: transparent,
          onClick: onClick
        }), children);
      }
      return /*#__PURE__*/React__default.createElement(StyledButton, _extends({}, getDataTaktAttributes(), rest, {
        disabled: disabled,
        type: type,
        ref: buttonRef || innerRef,
        $primary: primary,
        $small: small,
        $transparent: transparent,
        $loading: loading
      }, loading && {
        'aria-live': 'assertive'
      }, loading && {
        'aria-disabled': true
      }, {
        onClick: loading ? undefined : onClick
      }), loading && /*#__PURE__*/React__default.createElement(LoadingIcon, null), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, loading && loadingLabel ? loadingLabel : children));
    });
  }
}
_defineProperty(Button, "propTypes", {
  type: PT.oneOf(['submit', 'reset', 'button']),
  small: PT.bool,
  primary: PT.bool,
  disabled: PT.bool,
  href: PT.string,
  buttonRef: PT.oneOfType([PT.func, PT.shape({
    current: PT.instanceOf(typeof Element !== 'undefined' ? Element : Object)
  })]),
  innerRef: PT.oneOfType([PT.func, PT.shape({
    current: PT.instanceOf(typeof Element !== 'undefined' ? Element : Object)
  })]),
  transparent: PT.bool,
  loading: PT.bool,
  loadingLabel: PT.string,
  onClick: PT.func
});
_defineProperty(Button, "defaultProps", {
  type: 'button',
  small: false,
  primary: false,
  disabled: false,
  href: undefined,
  buttonRef: undefined,
  innerRef: undefined,
  transparent: false,
  loading: false,
  loadingLabel: undefined,
  onClick: undefined
});

export { Button as B, LoadingIcon as L, colorMixin as c };
//# sourceMappingURL=Button-Cv4kr51v.js.map
